<template>
  <page>
    <v-flex xs12>
      <v-card>
        <v-card-title>
          <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            dark
            class=" mr-2"
            @click="$router.push({ name: 'acctNoSfxDet', params: { acctNoSfx: 'new', acctNoSfxMode: 'New' } })"
          >
            New Account No. Suffix
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
          <v-btn color="info" dark class=" mr-2" @click="fetchData(true)">
            Refresh
            <v-icon right>mdi-refresh</v-icon>
          </v-btn>
          <download-csv :data="items" name="AcctNoSfxList.csv">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn class="mx-2" fab dark small color="primary" v-on="on">
                  <v-icon dark>mdi-download</v-icon>
                </v-btn>
              </template>
              <span>Download CSV</span>
            </v-tooltip>
          </download-csv>
        </v-card-title>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-flex>
          <v-card>
            <v-data-table
              :headers="headers"
              :items="items"
              :search="search"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              v-bind:options.sync="pagination"
              item-key="name"
              :loading="loading"
              :no-data-text="noDataText"
              :custom-filter="customSearch"
            >
              <template v-slot:item="row"
                ><tr>
                  <td class="text-xs-left">{{ row.item.acctNoSfx }}</td>
                  <td class="text-xs-left">{{ row.item.description }}</td>
                  <td class="table-action-header">
                    <table-action
                      :rowData="row"
                      review
                      @review="$router.push({ name: 'acctNoSfxDet', params: { acctNoSfx: row.item.acctNoSfx, acctNoSfxMode: 'Review' } })"
                      query
                      @query="$router.push({ name: 'acctNoSfxDet', params: { acctNoSfx: row.item.acctNoSfx, acctNoSfxMode: 'Query' } })"
                      remove
                      @remove="doDelete(row.item.acctNoSfx)"
                    ></table-action>
                  </td></tr
              ></template>
            </v-data-table>
          </v-card>
          <confirm ref="confirmDelete">
            <p>Are you sure you want to delete the selected Account No. Suffix and its related Mapping record? ({{ selectedAcctNoSfx }})</p>
          </confirm>
        </v-flex>
      </v-card>
    </v-flex>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
export default {
  data() {
    return {
      toogleArray: [false],
      headers: [{ text: 'Account No. Suffix', value: 'acctNoSfx' }, { text: 'Description', value: 'description' }, TableConst.tableActionHeader],
      labels: {
        acctNoSfx: 'Account No. Suffix',
        description: 'Description'
      },
      selectedAcctNoSfx: null,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.fetchData(true)
  },
  methods: {
    async fetchData(options) {
      const apiURI = this.menu.getAcctNoSfxListAll
      if (apiURI) {
        this.loading = true
        this.$http
          .get(apiURI)
          .then((result) => {
            this.items = []
            const { data } = result.data
            if (data) {
              data.map((results) => {
                const resultList = {
                  acctNoSfx: results.acctNoSfx,
                  description: results.description
                }
                this.items.push(resultList)
              })
            }
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    async doDelete(acctNoSfx) {
      const apiURI = this.menu.checkDeleteAcctNoSfx
      const apiURI2 = this.menu.deleteAcctNoSfx
      if (acctNoSfx && apiURI && apiURI2) {
        try {
          const expand = {
            acctNoSfx
          }
          await this.$http.get(expandURI(apiURI, expand))
          this.selectedAcctNoSfx = acctNoSfx
          const prompt = await this.$refs.confirmDelete.doPopUp()
          if (prompt) {
            const result = await this.$http.delete(expandURI(apiURI2, expand))
            const { data } = result
            this.notify(data)
            this.fetchData(false)
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.acctNoSfxParam.menu
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style>
</style>
